import _SvgIcon from "@material-ui/core/esm/SvgIcon";
import React from 'react';
import { variables } from 'swag-client-common/styles/variables-js';
export const SortHoverProductsListingIcon = ({
  svgColor = variables.colorWhite,
  className
}) => /*#__PURE__*/React.createElement(_SvgIcon, {
  width: "20",
  height: "14",
  viewBox: "0 0 20 14",
  fill: "none",
  className: className
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.70711 5.70711L4 3.41421V12.0769C4 12.5867 4.44772 13 5 13C5.55228 13 6 12.5867 6 12.0769V3.41421L8.29289 5.70711C8.68342 6.09763 9.31658 6.09763 9.70711 5.70711C10.0976 5.31658 10.0976 4.68342 9.70711 4.29289L5.70711 0.292893C5.31658 -0.0976311 4.68342 -0.0976311 4.29289 0.292893L0.292893 4.29289C-0.0976311 4.68342 -0.0976311 5.31658 0.292893 5.70711C0.683418 6.09763 1.31658 6.09763 1.70711 5.70711ZM14 1.92308V10.5858L11.7071 8.29289C11.3166 7.90237 10.6834 7.90237 10.2929 8.29289C9.90237 8.68342 9.90237 9.31658 10.2929 9.70711L14.2929 13.7071C14.6834 14.0976 15.3166 14.0976 15.7071 13.7071L19.7071 9.70711C20.0976 9.31658 20.0976 8.68342 19.7071 8.29289C19.3166 7.90237 18.6834 7.90237 18.2929 8.29289L16 10.5858V1.92308C16 1.41328 15.5523 1 15 1C14.4477 1 14 1.41328 14 1.92308Z",
  fill: svgColor
}));